// This icon file is generated automatically.
var PWrenchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.7 2.74a.2.2 0 00-.31-.04l-2.7 2.7-1.06-1.07 2.7-2.69a.2.2 0 00-.04-.31 4 4 0 00-5.9 4.48L.8 10.4a.12.12 0 000 .17l2.66 2.66c.05.04.13.05.17 0l4.58-4.58a4 4 0 004.49-5.9zm-1.42 4.07c-.9.9-2.27 1.08-3.35.52l-.14.14-4.28 4.28-1.24-1.23 3.6-3.6.82-.82a2.88 2.88 0 012.78-4.2L7.39 3.99a.5.5 0 000 .71l1.95 1.95c.2.2.5.2.7 0l2.08-2.08c.06.81-.23 1.64-.84 2.25z", "fill-rule": "nonzero" } }] }, "name": "p-wrench", "theme": "outlined" };
export default PWrenchOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PWrenchOutlined.js
// module id = 3736
// module chunks = 0